/**
 * File Object
 */
export class File {
    /**
     * @param {object} data
     * @param {number=} data.id
     * @param {string=} data.nom
     * @param {number=} data.procId
     * @param {string=} data.categorie
     * @param {boolean=} data.isTemp
     */
    constructor({
        id = 0,
        nom = null,
        procId = 0,
        categorie = null,
        isTemp = false,
    } = {}) {
        this.id = id
        this.nom = nom
        this.procId = procId
        this.categorie = categorie
        this.isTemp = isTemp
    }
}

/**
 * File Object used to bind error message
 */
export class ErrorFile {
    id
    nom
    procId
    categorie
}